import globalConfig from "../utils/config.json";
import { v4 as uuidv4 } from 'uuid';

export function verifyRecaptchaToken(token, callBack) {
  var requestBody = JSON.stringify({
    token: token,
  });

  fetch(process.env.REACT_APP_VERIFY_RECAPTCHA_URL, {
    method: "POST",
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: requestBody, // body data type must match "Content-Type" header
  })
    .then((response) => response.json())
    .then((result) => callBack(result, null))
    .catch((error) => callBack(null, error));
}

export function performPiRequest(callBack, MSISDN, code, countryConfig) {
  let transactionId = uuidv4();
  transactionId = process.env.REACT_APP_TRX_ID_PREFIX.concat(transactionId.slice(process.env.REACT_APP_TRX_ID_PREFIX.length));

  const clientId = getClientIdByCountry(countryConfig);

  var requestBody = JSON.stringify({
    client_id: clientId,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    env: globalConfig.env,
    correlation_id: transactionId,
    vf_transaction_id: transactionId,
    response_type: globalConfig.response_type,
    scopes: globalConfig.scopes,
    acr_values: globalConfig.acr_values,
    version: globalConfig.version,
    msisdn: countryConfig.prefix + MSISDN.trim(),
    code: code.trim(),
    webPageFlow: true,
  });

  fetch(process.env.REACT_APP_PREMIUM_INFO_URL, {
    method: "POST",
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      'vf-trace-transaction-id': transactionId
    },
    body: requestBody, // body data type must match "Content-Type" header
  })
    .then((response) => response.json())
    .then((result) => callBack(result, null))
    .catch((error) => callBack(null, error));
}

export function performAdditionalProductsRequest(callBack, MSISDN, countryConfig, scopesArray) {
  console.log("performAdditionalProductsRequest MSISDN: " + MSISDN +  " scopesArray: " + scopesArray);

  let transactionId = uuidv4();
  transactionId = process.env.REACT_APP_TRX_ID_PREFIX.concat(transactionId.slice(process.env.REACT_APP_TRX_ID_PREFIX.length));

  var requestBody = JSON.stringify({
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    env: globalConfig.env,
    scopes: scopesArray,
    msisdn: countryConfig.prefix + MSISDN.trim(),
  });

  fetch(process.env.REACT_APP_ADDITIONAL_PRODUCTS_URL, {
    method: "POST",
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      'vf-trace-transaction-id': transactionId
    },
    body: requestBody, // body data type must match "Content-Type" header
  })
    .then((response) => response.json())
    .then((result) => callBack(result, null))
    .catch((error) => callBack(null, error));
}

export function sendFeedbackToAwsLambda(description, callBack) {
  var requestBody = JSON.stringify({
    date: new Date().toISOString(),
    description: description,
  });

  fetch(process.env.REACT_APP_LAMBDA_TRIGGER_URL, {
    method: "POST",
    body: requestBody, // body data type must match "Content-Type" header
  })
    .then((response) => (response.ok ? response.json() : "errone"))
    // .then((result) => alert("Feedback successfully sent" + JSON.stringify(result)))
    // .catch((error) => alert("An error occurred sending the feedback. Please try again later."));
    .then((result) => callBack(result, null))
    .catch((error) => callBack(null, error));
}

export function generateAuthUrl(countryConfig) {
  const clientId = getClientIdByCountry(countryConfig);
  var authorizeUrl = new URL(process.env.REACT_APP_AUTHORIZE_URL);
  authorizeUrl.searchParams.append("redirect_uri", process.env.REACT_APP_REDIRECT_URI);
  authorizeUrl.searchParams.append("client_id", clientId);
  authorizeUrl.searchParams.append("scope", globalConfig.scopes);
  authorizeUrl.searchParams.append("response_type", globalConfig.responseType);
  authorizeUrl.searchParams.append("state", "0");
  authorizeUrl.searchParams.append("nonce", "super_random_nonce_1234456666");
  authorizeUrl.searchParams.append("acr_values", globalConfig.acrValues);
  authorizeUrl.searchParams.append("version", globalConfig.version);

  console.log("generated authorizeUrl: " + authorizeUrl.toString());
  return authorizeUrl.toString();
}

function getClientIdByCountry(countryConfig) {
  var clientId = "Va4GD2SCrkb7xBLpTL5gAGykrLikLSvx";

  const envConf = countryConfig.envConf.find(envConf => envConf.env === process.env.REACT_APP_ENV);
  if (envConf) {
    clientId = envConf.clientId;
  }

  console.log("getClientIdByCountry clientId: " + clientId);
  return clientId;
}
